import { create } from "zustand"
import { persist } from "zustand/middleware"
import { City } from "../types/entities/city"
import { Cinema } from "../types/entities/cinema"

type AppState = {
    city: City
    cinema: Cinema
    locationSelected: boolean
    pendingCity: City | null
    pendingCinema: Cinema | null
    reauthActive: boolean
    lastSmsCodeAt: string
    error: string | null
}

type AppActions = {
    setLocation: (newLocation: Partial<{ city: City; cinema: Cinema }>) => void
    setPendingLocation: (location: { city: City; cinema: Cinema }) => void
    clearPendingLocation: () => void
    setReauthActive: (active: boolean) => void
    setLastSmsCodeAt: (at: string) => void
    setError: (message: string | null) => void
}

type AppStore = AppState & AppActions

export const appStore = create<AppStore>()(
    persist(
        set => ({
            city: { id: 1, name: "Челябинск" },
            cinema: {
                id: 4,
                city_id: 1,
                name: "Мегаполис",
                logo: "https://static.comfortkino.ru/images/logo/cinema/800b46a4c8793abb43889932cbab33741.png"
            },
            pendingCity: null,
            pendingCinema: null,
            locationSelected: false,
            reauthActive: false,
            lastSmsCodeAt: "",
            error: null,

            setLocation: (newLocation: Partial<{ city: City; cinema: Cinema }>) =>
                set(prev => {
                    const nextCity = newLocation.city ?? prev.city
                    const nextCinema = newLocation.cinema ?? prev.cinema
                    if (nextCinema.city_id !== nextCity.id) {
                        return prev
                    }
                    return { ...prev, city: nextCity, cinema: nextCinema, locationSelected: true }
                }),

            setPendingLocation: ({ city, cinema }) => {
                if (cinema.city_id !== city.id) return
                set({ pendingCity: city, pendingCinema: cinema })
            },

            clearPendingLocation: () => set({ pendingCity: null, pendingCinema: null, reauthActive: false }),

            setReauthActive: (active: boolean) => set({ reauthActive: active }),

            setLastSmsCodeAt: (at: string) => set(() => ({ lastSmsCodeAt: at })),
            setError: message => set({ error: message })
        }),
        {
            name: "app-store",
            partialize: state => ({
                city: state.city,
                cinema: state.cinema,
                locationSelected: state.locationSelected,
                lastSmsCodeAt: state.lastSmsCodeAt
            }),
            version: 2,
            migrate: (persistedState: unknown, version: number) => {
                const s = persistedState as AppState
                if (version < 2 && s.locationSelected === undefined) {
                    return { ...s, locationSelected: false }
                }
                return s as AppState
            },
        }
    )
)
